module.exports = __webpack_public_path__ + "static/img/fgbg2-1.67dba17.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-1.png
// module id = 192
// module chunks = 0